"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.removeToastNotification = exports.clearToastNotifications = exports.addToastNotification = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var uuid_1 = require("uuid");
var ToastNotificationsList_1 = require("./ToastNotificationsList");
/**
 * Persistent reference to a "portal" for rendering the separate DOM tree
 */
var portal;
/**
 * Set default values for optional params
 */
var setDefaults = function (notificationMaybe) {
    var copy = __assign({}, notificationMaybe);
    if (typeof copy.id === "undefined") {
        copy.id = (0, uuid_1.v4)();
    }
    if (typeof copy.autohide === "undefined") {
        copy.autohide = true;
    }
    return copy;
};
/**
 * Create an instance of the toast notification manager
 * Renders ToastNotifications in an independent React tree
 * @returns {addToastNotification, removeToastNotification, clearToastNotifications}
 */
var createToastNotificationManager = function () {
    var setNotifications;
    if (portal === undefined && typeof window !== "undefined") {
        portal = document.createElement("div");
        portal.setAttribute("data-automation-id", "toast-notification-manager-portal");
        portal.setAttribute("data-testid", "toast-notification-manager-portal");
        portal.setAttribute("role", "status");
        document.body.appendChild(portal);
    }
    var state = {
        notifications: []
    };
    var addToastNotification = function (notification) {
        var notificationWithId = setDefaults(notification);
        var notificationIndex = state.notifications.findIndex(function (n) { return n.id === notification.id; });
        if (notificationIndex > -1) {
            var copy = state.notifications.slice();
            copy.splice(notificationIndex, 1, notificationWithId); // Mutation to insert notification over itself
            state.notifications = copy;
        }
        else {
            state.notifications = __spreadArray(__spreadArray([], state.notifications, true), [notificationWithId], false);
        }
        render();
    };
    var removeToastNotification = function (notificationID) {
        var notificationIndex = state.notifications.findIndex(function (notification) { return notification.id === notificationID; });
        var copy = state.notifications.slice();
        copy.splice(notificationIndex, 1); // Mutation
        state.notifications = copy;
        render();
    };
    var clearToastNotifications = function () {
        state.notifications = [];
        render();
    };
    var registerSetNotificationsCallback = function (cb) {
        setNotifications = cb;
        render();
    };
    var render = function () {
        if (setNotifications) {
            setNotifications(state.notifications);
        }
    };
    if (portal) {
        // eslint-disable-next-line react/no-deprecated
        react_dom_1["default"].render(react_1["default"].createElement(ToastNotificationsList_1.ToastNotificationsListContainer, { removeToastNotification: removeToastNotification, registerSetNotificationsCallback: registerSetNotificationsCallback }), portal);
    }
    return {
        addToastNotification: addToastNotification,
        clearToastNotifications: clearToastNotifications,
        removeToastNotification: removeToastNotification
    };
};
/**
 * Singleton instance of the toast notification manager
 */
var instance = createToastNotificationManager();
/**
 * Export the curried API methods
 */
exports.addToastNotification = instance.addToastNotification;
exports.clearToastNotifications = instance.clearToastNotifications;
exports.removeToastNotification = instance.removeToastNotification;
//# sourceMappingURL=ToastNotificationManager.js.map